import React, { Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import PageLoading from "@/components/conatiners/page-loading";

const DiscoveryPage = React.lazy(() => import("@/pages/platform/DiscoveryPage"));

/**
 * Route tree for a platform host (rasoix.app).
 *
 * Separate from {@link import("@/web-routes/web-routes").default} rather than a branch
 * inside it: every storefront route depends on a resolved tenant, and the platform host
 * has none. Keeping the trees apart is what makes it impossible to reach cart, checkout
 * or account from the platform origin.
 *
 * `/r/{slug}` is deliberately absent. That path is decided one level up — the entry-mode
 * resolver matches the alias slug before it looks at the hostname — so rasoix.app/r/{slug}
 * mounts the storefront tree exactly as it did before platform mode existed and never
 * reaches this file.
 */
export default function PlatformRoutes() {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <Suspense fallback={<PageLoading />}>
            <DiscoveryPage />
          </Suspense>
        }
      />
      {/* No 404 page here yet: an unknown platform path is far more likely to be a stale
          storefront link than a real destination, so send it to discovery. */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
